import React, { useEffect, useState } from "react";
import { getDownloadLicense } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const LicenseView1: React.FC<{ docId: string | null }> = ({ docId }) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string>("License.pdf");
  const [loading, setLoading] = useState(false);

  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state: any) => state.auth.language);

  useEffect(() => {
    const loadPdf = async () => {
      if (!docId) return;

      setLoading(true);
      try {
        const response = await getDownloadLicense(token, docId);

        // 🔹 Extract filename from header
        const disposition = response.headers["content-disposition"];
        if (disposition) {
          const match = disposition.match(/filename="?(.+)"?/);
          if (match) setFileName(match[1]);
        }

        // 🔹 Create blob URL
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (err) {
        console.error("PDF load failed", err);
        setPdfUrl(null);
      }
      setLoading(false);
    };

    loadPdf();

    // 🔹 Cleanup memory
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [docId]);

  return (
    <div className="modal fade" id="license_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdoc}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" />
          </div>

          <div className="modal-body" style={{ maxHeight: "500px", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !pdfUrl && <p>No document found</p>}

            {pdfUrl && (
              <iframe
                src={pdfUrl}
                width="100%"
                height="500px"
                title="License PDF"
              />
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            {pdfUrl && (
              <a
                href={pdfUrl}
                download={fileName}
                className="btn btn-success"
              >
                {language.down}
              </a>
            )}
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseView1;
